// Dependencies
import React, { Component } from 'react';
import { getLanguage, withTranslation } from 'react-multi-lang';

// Primereact imports
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';

// Utils
import { CV, DOC_TYPE_CV } from '../../../../common/constants';
import { getCVTypeList, isCVTypeFile, isCVTypeUrl } from '../../../../common/lists/other';
import { formatQualificationCvDataFormValues } from '../../../../common/formatters/qualification-cv-data';
import { convertBase64ToArrayBuffer, downloadFile } from '../../../../common/utils/download-utils';
import { formatAssociateDataToService } from '../../../../common/formatters/associate';
import { getRegistrationDoc } from '../../../../common/utils/registration-utils';

// Styling
import './cv-data.scss';

// Redux
import { connect } from 'react-redux';
import DocumentService from '../../../../redux/services/document';
import { getAssociateData, setEditMode } from '../../../../redux/actions/profile';
import ProfileService from '../../../../redux/services/profile';

class CvDataComponent extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            associate: null,
            readOnlyMode: true,
            cvAttachment: null,
            cvAttachmentName: "",
            cvDoc: null,
            // Mandatory fields validation
            validCvUrl: true,
            validCvFile: true,
            validUploadFile: true
        };
    }

    componentDidMount() {
        let associate = this.props.associate;

        this.setState({
            associate: formatQualificationCvDataFormValues(associate, this.props.language),
            cvDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_CV)
        });
    }

    downloadDocument(documentRef) {
        DocumentService.downloadDocument(documentRef)
            .then((response) => {
                var blob = new Blob([convertBase64ToArrayBuffer(response.fileContent)], { type: response.contentType });
                downloadFile(URL.createObjectURL(blob), response.filename);
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
            });
    }

    activateEditMode() {
        this.setState({
            readOnlyMode: false
        });

        this.props.setEditMode(true);
    }

    cancelEditMode() {
        this.setState({
            associate: formatQualificationCvDataFormValues(this.props.associate, this.props.language),
            readOnlyMode: true,
            validCvUrl: true,
            cvAttachment: null,
            cvAttachmentName: ""
        });
        this.props.setEditMode(false);
    }

    saveChanges() {
        if(this.validateForm()) {
            ProfileService.updateAssociateData(formatAssociateDataToService(this.state.associate), this.props.t('general.update-record'), CV)
            .then((response) => {

                // Upload CV file if needed
                if(this.state.cvAttachment !== null) {
                    ProfileService.uploadAssociateDocument(this.state.cvAttachment, this.props.registrationRef.toString(), DOC_TYPE_CV)
                    .then((response) => {
                        this.props.getAssociateData(this.props.registrationRef);

                        setTimeout(() => {
                            this.setState({
                                cvDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_CV)
                            });
                        }, 1500);
                    })
                    .catch(error => {
                        this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
                    });
                }
                else {
                    this.props.getAssociateData(this.props.registrationRef);

                    setTimeout(() => {
                        this.setState({
                            cvDoc: getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_CV)
                        });
                    }, 1500);
                }

                this.setState({
                    readOnlyMode: true,
                    cvAttachment: null,
                    cvAttachmentName: ""
                });
    
                this.props.setEditMode(false);
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
            });
        }
    }

    updateFormComponent(column, value) {
        let associate = this.state.associate;
        associate.qualificationData[column] = value;

        if(column === "cvType" && isCVTypeFile(value)) {
            associate.qualificationData.cvUrl = "";
        }

        this.setState({
            associate: associate
        });
    }

    validateForm() {
        let validationResult = true;

        if(isCVTypeUrl(this.state.associate.qualificationData.cvType)) {
            this.setState({
                validCvUrl: this.state.associate.qualificationData.cvUrl !== "",
                validCvFile: true
            });

            validationResult = (this.state.associate.qualificationData.cvUrl !== "");
        }
        else {
            //let cvDoc = getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_CV);

            this.setState({
                validCvFile: this.state.cvDoc === null ? this.state.cvAttachment !== null : true,
                validCvUrl: true
            });

            validationResult = this.state.cvDoc === null ? this.state.cvAttachment !== null : true;
        }

        return validationResult;
    }

    uploadDocumentHandler(document) {
        let self = this;
        var reader = new FileReader();
            reader.readAsBinaryString(document[0]);

            reader.onload = function() {
                self.setState({
                    cvAttachment: btoa(reader.result),
                    cvAttachmentName: document[0].name,
                    validUploadFile: true
                });
            };
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language) {
            let associate = this.props.associate;

            this.setState({
                associate: formatQualificationCvDataFormValues(associate, this.props.language)
            });
        }
    }
    
    render() {
        return (
            this.state.associate !== null && this.state.associate.qualificationData !== null ? 
            <div className='grid'>
                <div className='col-12'>
                    <div className="card p-fluid mgt-20">
                        <div className='grid'>
                                <div className='col-12 t-align-right'>
                                    {
                                        this.state.readOnlyMode === true ? 
                                            <Button icon="pi pi-pencil" className="p-button-rounded mr-2 mb-2" disabled={!this.props.registrationApproved} onClick={() => this.activateEditMode()} />
                                            :   
                                            <>
                                                <Button icon="pi pi-check" className="p-button-rounded p-button-success mr-2 mb-2" onClick={() => this.saveChanges()} />
                                                <Button icon="pi pi-ban" className="p-button-rounded p-button-danger mr-2 mb-2" onClick={() => this.cancelEditMode()} />
                                            </>
                                    }
                                </div>  
                                <div className='col-12 t-align-left'>
                                    <label htmlFor="cvType">{this.props.t("profile.areas.qualification.areas.cv.cv-type")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="cvType" value={this.state.associate.qualificationData.cvType} disabled={this.state.readOnlyMode} options={getCVTypeList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("cvType", evt.value)}></Dropdown>
                                </div>
                                {
                                    isCVTypeUrl(this.state.associate.qualificationData.cvType) ?
                                        <div className='col-12 t-align-left'>
                                            <label htmlFor="cvUrl">{this.props.t("profile.areas.qualification.areas.cv.cv-url")} <span className="invalid-message">*</span></label>
                                            <InputText id="cvUrl" disabled={this.state.readOnlyMode} value={this.state.associate.qualificationData.cvUrl} type="text" onChange={(evt) => this.updateFormComponent("cvUrl", evt.target.value)} />
                                            { this.state.validCvUrl ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>
                                        : null
                                }
                                {
                                    !isCVTypeUrl(this.state.associate.qualificationData.cvType) && this.state.cvDoc !== null && this.state.cvAttachment === null ?
                                        <div className='col-12 md:col-12 lg:col-3 t-align-left'>                             
                                            <span onClick={() => this.downloadDocument(this.state.cvDoc.nodeRef)}>
                                                <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.qualification.areas.cv.document")} icon="pi pi-download" className="mr-2 mb-2" />
                                            </span>
                                        </div>
                                        : null
                                }
                                {
                                    !isCVTypeUrl(this.state.associate.qualificationData.cvType) && this.state.readOnlyMode === false ?
                                        <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                            <FileUpload mode="basic" 
                                                        accept="application/pdf" 
                                                        chooseLabel={this.props.t("profile.areas.qualification.areas.cv.upload-cv")}
                                                        maxFileSize={1000000} 
                                                        uploadHandler={(evt) => this.uploadDocumentHandler(evt.files)} customUpload={true} auto={true}

                                                        onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                                            {
                                                this.state.cvAttachment !== null ? 
                                                    <span>{this.state.cvAttachmentName}</span> : null
                                            }
                                        </div>
                                        : null
                                }
                                { this.state.validUploadFile ? null : <div className='col-12 t-align-left'><small className="p-error">{this.props.t("profile.areas.qualification.areas.cv.invalid-cv-file")}</small></div>  }
                        </div>
                    </div>
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
            : null
        );
    }
}

const mapStateToProps = (state) => {
  return {
      associate: state.profile.associate,
      registrationDocs: state.profile.registrationDocs,
      registrationRef: state.authentication.registrationRef,
      registrationApproved: state.authentication.registrationApproved,
      language: state.profile.language
  } 
};

const mapDispatchToProps = (dispatch) => {
  return {
    setEditMode: (editMode) => { dispatch(setEditMode(editMode)) },
    getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(CvDataComponent));